import { render, staticRenderFns } from "./StatusChanger.vue?vue&type=template&id=51c06b9a&"
import script from "./StatusChanger.vue?vue&type=script&lang=js&"
export * from "./StatusChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports